import { compose } from 'redux'

import Ocr from './Ocr'
import OcrStateConnect from './Ocr.connect'

export default compose(
  OcrStateConnect
)(Ocr)
